import { type SVGProps, useId } from "react";

export function ListingsIcon(props: SVGProps<SVGSVGElement>) {
	const titleId = useId();
	const clipId = useId();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			strokeWidth={1.5}
			role="img"
			aria-labelledby={titleId}
			{...props}
		>
			<title id={titleId}>Listings</title>
			<g clipPath={`url(#${clipId})`}>
				<path
					d="M3.99992 14.6668V2.66683C3.99992 2.31321 4.14039 1.97407 4.39044 1.72402C4.64049 1.47397 4.97963 1.3335 5.33325 1.3335H10.6666C11.0202 1.3335 11.3593 1.47397 11.6094 1.72402C11.8594 1.97407 11.9999 2.31321 11.9999 2.66683V14.6668M3.99992 14.6668H11.9999M3.99992 14.6668H2.66659C2.31296 14.6668 1.97382 14.5264 1.72378 14.2763C1.47373 14.0263 1.33325 13.6871 1.33325 13.3335V9.3335C1.33325 8.97987 1.47373 8.64074 1.72378 8.39069C1.97382 8.14064 2.31296 8.00016 2.66659 8.00016H3.99992M11.9999 14.6668H13.3333C13.6869 14.6668 14.026 14.5264 14.2761 14.2763C14.5261 14.0263 14.6666 13.6871 14.6666 13.3335V7.3335C14.6666 6.97987 14.5261 6.64074 14.2761 6.39069C14.026 6.14064 13.6869 6.00016 13.3333 6.00016H11.9999M6.66658 4.00016H9.33325M6.66658 6.66683H9.33325M6.66658 9.3335H9.33325M6.66658 12.0002H9.33325"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id={clipId}>
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
